import {$, $$, createElement} from "../../core/js/Dom.ts";
import {getMessagerieList} from "../../core/js/Messagerie.ts";
import {initSelects} from "../../core/js/Select.ts";
import {initTooltips} from "../../core/js/Tooltip.ts";
import {initCarto, updateAlerteCarto} from "../../carto/js/Cartographie.ts";
import {initHistoryModal} from "../../core/js/Modal.ts";
import {initPieceJointeOnglet} from "../../instructions/js/InstructionPiecesJointes.ts";
import {handleShowAvis} from "../../instructions/js/ShowAvis.ts";
import {initGeographieOnglet, viderOngletGeographie} from "../../core/js/Geographie.ts";
import {TabSystem} from "../../core/js/Dossier.ts";
import {initLinkToOnglet, updateMenuInfos} from "../../core/js/Onglets.ts";
import {initActions} from "../../core/js/Actions.ts";
import {deplier_tous_accordeons} from "../../core/js/Utils.ts";

document.addEventListener('DOMContentLoaded', () => {
    if (document.body.dataset.url?.endsWith('_detail')) {
        initListeners()
        const tabs = new TabSystem()
        tabs.addEventListener('panel-loaded', handlePanelLoaded)
        initActions()
        updateMenuInfos()
    }
})

function handlePanelLoaded(event: CustomEvent<panelLoaded>) {
    const target = event.detail.target
    const source = event.detail.source
    if(target) {
        if(target.id !== "geographie") viderOngletGeographie()
        initSelects(target)
        initTooltips(target)
        initHistoryModal(target)
        initListeners()
        initDetail()
        switch (target.id) {
            case "messagerie":
                getMessagerieList(source.dataset.manif)
                break;
            case "pre-instruction":
                $$(`.fr-accordion__btn`).forEach(el => el.addEventListener('click', handleShowAvis))
                break;
            case "parcours":
                if(source) source.dataset.loaded = "true"
                initCarto()
                updateAlerteCarto()
                break;
            case "geographie":
                initGeographieOnglet()
                break;
            case "formulaire":
                break;
            case "pieces-jointes":
                initPieceJointeOnglet()
                break;
            case "n2k":
                break;
            case "rnr":
                break;
            case "documents-officiels":
                break;
        }
    }
}

function initListeners() {
    $('.deplier-accordions')?.addEventListener('click', deplier_tous_accordeons)
    initLinkToOnglet(document.body)
}

function initDetail() {
    window.Openscop.liste_champ.forEach((champData: any[]) => {
        const [classe, id, date, motif] = champData
        const element = $<HTMLElement>(`#${id}.${classe}`)
        if (element) {
            element.classList.add('champ-a-modifier', 'gx-3', 'fr-py-2w');
            const divModif = document.createElement('div');
            divModif.classList.add(
                'raison_demande_modification',
                'fr-alert',
                'fr-alert--info',
                'fr-col-12',
            );
            divModif.innerText = `Modification demandée le ${date} pour la raison suivante : "${motif}"`

            if (element.querySelector('.raison_demande_modification') === null) {
                element.appendChild(divModif);
            }

            const newElement = createElement('div')
            let newElementUrl = window.Openscop.url_dossier_edit + `${id}/`
            if (element.classList.contains('n2k')) {
                newElementUrl = window.Openscop.url_n2k + `${id}/`
            }
            if (element.classList.contains('rnr')) {
                newElementUrl = window.Openscop.url_rnr + `${id}/`
            }
            newElement.innerHTML = `<a href="${newElementUrl}" class="fr-btn fr-btn--sm btn-modife-champ" role="button"><i class="remix-editer sm" aria-hidden="true"></i>Modifier</a>`
            if (element.querySelector('.btn-modife-champ') === null) {
                $('.valeur .actions', element)?.appendChild(newElement)
            }
            initTooltips(element.parentElement)
        }
    })
}
